import { useMemo } from 'react';
import { cityByAirport } from '@voll-intelligence/domain';
import {
  FlightFilterPanel as KitFlightFilterPanel,
  type FlightFilterPanelProps as KitFlightFilterPanelProps,
} from '@voll-intelligence/intelligence-ui-kit';
import { useGenUiI18n } from '../../../shared/ui/i18n.js';
import { useGenUiTelemetry } from '../../../shared/ui/telemetry.js';
import { flightFilterCopy } from '../../../shared/ui/flight_filter_copy.js';

export type FlightFilterPanelProps = Omit<
  KitFlightFilterPanelProps,
  'copy' | 'locale' | 'cityOf' | 'onFacetApplied'
>;

/**
 * O `FlightFilterPanel` do kit (#4997, C2a) ligado ao que só o genui-kit tem:
 * os textos do catálogo no locale do `GenUiConfig`, a cidade do domain e o
 * `filter_applied` da telemetria. O drawer do card e o explorer montam este;
 * as props de corte e de casca passam direto.
 */
export function FlightFilterPanel(props: Readonly<FlightFilterPanelProps>) {
  const { locale } = useGenUiI18n();
  const telemetry = useGenUiTelemetry();
  const copy = useMemo(() => flightFilterCopy(locale), [locale]);
  return (
    <KitFlightFilterPanel
      {...props}
      copy={copy}
      locale={locale}
      cityOf={cityByAirport}
      onFacetApplied={(facet) => {
        telemetry.track('filter_applied', { facet });
      }}
    />
  );
}
